var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTextWriteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 13.1005C13.2175 13.1005 12.1 14.218 12.1 15.6005V34.8005C12.1 34.8364 12.1086 34.8488 12.1124 34.8542C12.1196 34.8644 12.1349 34.8791 12.1598 34.8896C12.1847 34.9 12.2056 34.9005 12.2176 34.8985L12.2177 34.8985C12.2238 34.8974 12.2397 34.8948 12.267 34.8679C12.2671 34.8678 12.2673 34.8676 12.2674 34.8675L17.167 30.0279C17.3729 29.8245 17.6506 29.7105 17.94 29.7105H33.4C34.7825 29.7105 35.9 28.593 35.9 27.2105V15.6005C35.9 14.218 34.7825 13.1005 33.4 13.1005H14.6ZM9.90002 15.6005C9.90002 13.003 12.0025 10.9005 14.6 10.9005H33.4C35.9975 10.9005 38.1 13.003 38.1 15.6005V27.2105C38.1 29.808 35.9975 31.9105 33.4 31.9105H18.3917L13.813 36.4331L13.8127 36.4334C12.3563 37.8706 9.90002 36.8351 9.90002 34.8005V15.6005Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0098 25.9804H24.0098V23.7804H31.0098V25.9804Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7806 18.3305L23.6306 17.1805C23.4706 17.0205 23.2006 17.0205 23.0406 17.1805L16.4906 23.7305L16.1806 25.2905C16.1206 25.5805 16.3806 25.8305 16.6706 25.7805L18.2306 25.4705L24.7806 18.9205C24.9406 18.7605 24.9406 18.4905 24.7806 18.3305Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextWriteLight);
export default __webpack_public_path__ + "static/media/icon_text_write_light.22bccff9.svg";
export { ForwardRef as ReactComponent };